import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ShippingMethodLayer from "../components/ShippingMethodLayer";

const ShippingMethodPage = () => {
    return (
        <MasterLayout>
            <ShippingMethodLayer />
        </MasterLayout>
    );
};

export default ShippingMethodPage;
